import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { getCanonicalUrl } from "../utils/seoConfig";
import { blogPosts } from "../data/blogPosts";
import { formatBlogDate } from "../utils/formatBlogDate";
import "../styles/blog.scss";

function Blog() {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const isDe = i18n.language && i18n.language.startsWith("de");

  return (
    <>
      <Helmet>
        <title>{t("BlogPageTitle")}</title>
        <meta name="description" content={t("BlogPageDescription")} />
        <link rel="canonical" href={getCanonicalUrl("/blog")} />
      </Helmet>
      <div className="App">
        <section className="section blog-list">
          <div className="blog-layout">
            <aside className="blog-sidebar">
              <h2 className="blog-sidebar-title">{t("BlogHeroTitle")}</h2>
              <p className="blog-sidebar-subtitle">{t("BlogHeroSubtitle")}</p>
              <div className="blog-sidebar-divider" />
              <p className="blog-sidebar-list-heading">{t("Latest")}</p>
              <ul className="blog-sidebar-list">
                {blogPosts.map((post) => (
                  <li key={post.slug} className="blog-sidebar-item">
                    <Link to={`/blog/${post.slug}`} className="blog-sidebar-link">
                      {isDe && post.shortTitleDe
                        ? post.shortTitleDe
                        : post.shortTitle || post.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </aside>

            <div className="blog-main">
              <div className="blog-grid">
                {blogPosts.map((post) => {
                  const hasImage = !!post.image;
                  const cardImageStyle = hasImage
                    ? { backgroundImage: `url(${post.image})` }
                    : undefined;
                  const localizedCardTitle =
                    isDe && post.titleDe ? post.titleDe : post.title;
                  const localizedCardExcerpt =
                    isDe && post.excerptDe ? post.excerptDe : post.excerpt;

                  return (
                    <Link
                      key={post.slug}
                      to={`/blog/${post.slug}`}
                      className="blog-card"
                    >
                      <div
                        className={`blog-card-image${
                          hasImage ? " blog-card-image--photo" : ""
                        }`}
                        style={cardImageStyle}
                      />
                      <div className="blog-card-content">
                        <span className="blog-card-category">
                          {post.category}
                        </span>
                        <h2 className="blog-card-title">{localizedCardTitle}</h2>
                        <p className="blog-card-excerpt">
                          {localizedCardExcerpt}
                        </p>
                        <div className="blog-card-meta">
                          <span>{post.author}</span>
                          <span>{formatBlogDate(post.date)}</span>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Blog;
